(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener("DOMContentLoaded", function(){

  document.querySelectorAll(".submenu-arrow").forEach(function(arrow){

  arrow.addEventListener("click", function(){

  let parent = this.closest(".menu-item");

  parent.classList.toggle("active");

  });

  });

  });

  } catch(e) { console.error(e); }
})();
})();
